
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const RevolutionaryApproach = () => (
  <div className="bg-secondary/5 py-24 px-6">
    <div className="max-w-5xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div className="space-y-6">
          <span className="premium-subtitle text-accent">Our Approach</span>
          <h2 className="premium-title">
            A revolutionary approach to financial data
          </h2>
          <p className="premium-body leading-relaxed">
            While traditional financial institutions hoard your financial data to maximize their profits, we're building a platform that unlocks the power of your data to serve you — providing insights that lead to financial clarity and freedom.
          </p>
          <ul className="space-y-3">
            <li className="flex items-start gap-3">
              <span className="mt-1 text-accent font-bold">•</span>
              <span className="text-foreground text-sm">User ownership of financial data</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-1 text-accent font-bold">•</span>
              <span className="text-foreground text-sm">Insights that drive financial well-being</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-1 text-accent font-bold">•</span>
              <span className="text-foreground text-sm">No hidden fees or agendas</span>
            </li>
          </ul>
        </div>
        <div className="relative h-80">
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-accent/5 to-background rounded-2xl" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-40 h-40 rounded-full bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center">
              <div className="text-4xl font-display font-bold text-primary/70">
                cheqbooq
              </div>
            </div>
            <div className="absolute w-52 h-52 rounded-full border border-primary/10 animate-ping" style={{ animationDuration: '4s' }} />
            <div className="absolute w-32 h-32 rounded-full border border-accent/20" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default RevolutionaryApproach;
